import script from "./BannerInner.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerInner.vue?vue&type=script&setup=true&lang=js"

import "./BannerInner.vue?vue&type=style&index=0&id=b3a59ba2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3a59ba2"]])

export default __exports__